import { isApiClientError } from "@nudgebox/api-client";

/** Human message for any thrown error; API errors carry a safe, specific message. */
export function errorMessage(error: unknown, fallback = "Something went wrong. Please try again."): string {
  if (isApiClientError(error)) return error.message;
  if (error && typeof error === "object" && "message" in error && typeof error.message === "string") {
    return error.message;
  }
  return fallback;
}

/** Field-level errors from an `invalid_request` response, keyed by path. */
export function fieldErrors(error: unknown): Record<string, string> {
  if (!isApiClientError(error)) return {};
  return Object.fromEntries(error.issues.map((issue) => [issue.path, issue.message]));
}
